import { RootState } from 'app/store';

export const selectSending = (state: RootState) => state.contact.sending;

export const selectSendingError = (state: RootState) =>
  state.contact.sendingError;
